import { RouteObject } from 'react-router-dom';
import { Loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.billing,
    element: <Loadable component={() => import('./pages/BillingPage')} />,
  },
];
